import { render, staticRenderFns } from "./input-modal.vue?vue&type=template&id=06d8c985&"
import script from "./input-modal.vue?vue&type=script&lang=js&"
export * from "./input-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports